// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3nENm","rootSuccess":"CompleteLink_rootSuccess__1nmep","rootFailure":"CompleteLink_rootFailure__3MtRy","isDisabled":"CompleteLink_isDisabled__1Mu2_"};